import {action, observable} from 'mobx';
import {DomainStore} from 'shared/store';
import {t, endpoints, types} from 'shared/core';
import {successAlert} from 'shared/tools';

class CycleDirectoryState {
  history;
  store = new DomainStore();

  @observable selectedCycle;

  receiveProps({history}) {
    this.history = history;
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  @action async addNewCycle() {
    const {model} = await this.store.post(
      endpoints.PERFORMANCE_REVIEWS.CYCLES.DIRECTORY,
      types.PERFORMANCE_REVIEWS.CYCLE
    );

    this.history.push(`/reviews/${model.id}/edit`);
  }

  @action async removeCycle(cycle) {
    await this.store.destroy(cycle);
  }

  @action async reopenCycle() {
    if (!this.selectedCycle) return;
    
    const {model} = await this.store.patch(
      this.selectedCycle.link('reopen'),
      types.PERFORMANCE_REVIEWS.CYCLE,
      this.selectedCycle
    );

    if (model) {
      this.interactiveAgent.refresh();
      successAlert(t('performance.reopen_modal.Review cycle reopened.'));
      this.closeReopenCycleModal();
    }
  }

  cyclePath(cycle) {
    switch (cycle.state) {
      case 'created':
        return `/reviews/${cycle.id}/edit`;
      case 'configured':
        return `/reviews/${cycle.id}/manage`;
      case 'launched':
      case 'ended':
      default:
        return `/reviews/${cycle.id}`;
    }
  }

  customLinksFor(cycle) {
    if (cycle.hasLink('reopen')) {
      return [
        {
          order: 0,
          text: 'performance.Reopen',
          action: model => this.openReopenCycleModal(model)
        }
      ]
    }
    
    return [];
  }
}

export default CycleDirectoryState;
